<template>
  <div class="cloud-path-content">
    <div class="program-content">
      <div class="program-content-header">
        <div>
          <a-icon type="code" style="margin-right: 4px" />{{ $t('page_my_document_program') }}
        </div>
      </div>
      <div id="program-content-list" class="program-content-list">
        <source-table
          :scrollY="programScrollY"
          :columns="columns"
          :dataSource="programList"
          :loading="loading"
        ></source-table>
      </div>
    </div>

    <div class="documents-content">
      <div class="documents-content-header">
        <div>
          <a-icon type="wallet" style="margin-right: 4px" />{{ $t('page_my_document_process') }}
        </div>
      </div>
      <div id="documents-content-list" class="documents-content-list">
        <source-table
          :scrollY="fileScrollY"
          :columns="columns"
          :dataSource="fileList"
          :loading="loading"
        ></source-table>
      </div>
    </div>
    <preview-modal
      :visible="previewVisible"
      :data="previewData"
      @close="closePreview"
    ></preview-modal>
  </div>
</template>

<script>
import { downloadGET } from '@/api/api'
import { downloadFile } from '@/utils'
import PreviewModal from '../../components/PreviewModal.vue'
import SourceTable from './File/SourceTable.vue'
import {
  TransferDirectoryFileQueryServiceProxy,
  TransferDirectoryFileServiceProxy
} from '@/service-proxies/app-v2/dnc.service-proxies'
const tdfsp = new TransferDirectoryFileServiceProxy()
const tdfqsp = new TransferDirectoryFileQueryServiceProxy()
import dayjs from 'dayjs'

export default {
  components: {
    SourceTable,
    PreviewModal
  },
  data() {
    return {
      columns: [
        {
          title: this.$t('actions'),
          dataIndex: 'actions',
          ellipsis: true,
          customRender: (_, record) => {
            return (
              <div>
                <a-popconfirm
                  title={this.$t('page_transport_directory_sure_to_delete_the_file')}
                  onConfirm={() => this.handleDelete(record)}
                  okText={this.$t('ok')}
                  cancelText={this.$t('cancel')}
                >
                  <a class="del-color">{this.$t('delete')}</a>
                </a-popconfirm>
                <a-divider type="vertical" />
                <a
                  onClick={(e) => {
                    e.stopPropagation()
                    this.handleDownload(record)
                  }}
                >
                  {this.$t('page_my_document_download')}
                </a>
                <a-divider type="vertical" />
                <a
                  onClick={(e) => {
                    e.stopPropagation()
                    this.handlePrev(record)
                  }}
                  disabled={record.suffix === 'zip'}
                >
                  {this.$t('preview')}
                </a>
              </div>
            )
          }
        },
        {
          title: this.$t('page_my_document_filenm'),
          dataIndex: 'name',
          ellipsis: true,
          scopedSlots: { customRender: 'name' }
        },
        {
          title: this.$t('page_my_document_size'),
          dataIndex: 'contentLength',
          width: 108,
          ellipsis: true,
          scopedSlots: { customRender: 'contentLength' }
        },
        {
          title: this.$t('page_my_document_type'),
          dataIndex: 'fileType',
          width: 128,
          key: 'fileType',
          customRender: (text) => {
            return text == 1 ? this.$t('page_my_document_program') : this.$('page_my_document_process')
          }
        },
        {
          title: this.$t('page_transport_directory_upload_time'),
          dataIndex: 'lastModified',
          key: 'lastModified',
          width: 188,
          ellipsis: true,
          customRender: (text) => {
            return text ? dayjs(text).format('YYYY-MM-DD HH:mm:ss') : ''
          }
        }
      ],
      programList: [],
      fileList: [],
      programRowKeys: [],
      fileRowKeys: [],
      programScrollY: 0,
      fileScrollY: 0,
      previewData: {},
      previewVisible: false,
      loading: false
    }
  },
  props: {
    selectedKey: {
      // 选择树节点
      type: String,
      default: ''
    },
    bottomUplod: {
      type: Number,
      default: 0
    }
  },
  watch: {
    selectedKey: {
      handler() {
        if (this.selectedKey.length) this.getData()
      },
      immediate: true,
      deep: true
    },
    bottomUplod: {
      handler() {
        if (this.selectedKey.length) this.getData()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleDelete(record) {
      tdfsp.delete(record.id).then(() => {
        this.$message.success(this.$t('page_transport_directory_file_deleted_successfully'))
        this.getData()
      })
    },
    handleDownload(record) {
      downloadGET(record.objectKey, record.objectKey, record.contentType).then((res) => {
        downloadFile(res, record.originalFilename || record.fileName)
      })
    },
    handlePrev(record) {
      this.previewData = record
      this.previewVisible = true
    },
    closePreview() {
      this.previewData = {}
      this.previewVisible = false
    },
    async getData() {
      this.programList = []
      this.fileList = []
      let id = ''
      if (this.selectedKey.indexOf('-') === -1) {
        id = this.selectedKey
      } else {
        const index = this.selectedKey.indexOf('-')
        id = this.selectedKey.substring(index + 1)
      }
      this.loading = true
      const data = await tdfqsp.fileList('', id)
      if (data && data.length) {
        const dataSource = data.map((res) => {
          res['name'] = res.originalFilename
          return res
        })
        this.programList = dataSource.filter((res) => res.fileType == 1)
        this.fileList = dataSource.filter((res) => res.fileType == 2)
      }
      this.getScroll(this.programList, this.fileList)
      this.loading = false
    },
    getScroll(programList, fileList) {
      const programDiv = document.getElementById('program-content-list')
      if (programDiv) {
        const pheight = programList.length * 33
        if (pheight > programDiv.clientHeight - 48) {
          this.programScrollY = programDiv.clientHeight - 50
        } else {
          this.programScrollY = 0
        }
      }
      const fileDiv = document.getElementById('documents-content-list')
      if (fileDiv) {
        const fheight = fileList.length * 33
        if (fheight > fileDiv.clientHeight - 48) {
          this.fileScrollY = fileDiv.clientHeight - 50
        } else {
          this.fileScrollY = 0
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.cloud-path-content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 8px;
  height: calc(100% - 38px);
  width: 100%;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: flex-start;

  .program-content {
    background-color: #f8f8f8;
    border-radius: 2px;
    border: solid 1px #52c41a;
    height: calc(50% - 4px);
    &-header {
      padding: 8px 16px;
      font-size: 16px;
      letter-spacing: 0px;
      background-color: #f6ffed;
      color: #52c41a;
      border-bottom: 1px solid #52c41a;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .header-tip {
        font-size: 12px;
        line-height: 22px;
        color: rgba(0, 0, 0, 0.85);
        .program-tip-type {
          color: #52c41a;
        }
      }
    }
    &-list {
      padding: 8px;
      height: calc(100% - 41px);
      overflow-y: auto;
    }
    .program-content-file-box {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
    }
  }

  .documents-content {
    background-color: #f8f8f8;
    border: solid 1px #597ef7;
    border-radius: 2px;
    height: calc(50% - 4px);
    &-header {
      padding: 8px 16px;
      font-size: 16px;
      letter-spacing: 0px;
      background-color: #f0f5ff;
      color: #597ef7;
      border-bottom: 1px solid #597ef7;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .header-tip {
        font-size: 12px;
        line-height: 22px;
        color: rgba(0, 0, 0, 0.85);
        .documents-tip-type {
          color: #597ef7;
        }
      }
    }
    &-list {
      padding: 8px;
      height: calc(100% - 41px);
      overflow-y: auto;
    }
    .documents-content-file-box {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
    }
  }
}
</style>
